import { Box } from "@material-ui/core";
import React from "react";
import styled from "styled-components";

// Styled component for the rounded box with fixed positioning
const StyledBox = styled(Box)`
  cursor: pointer;
  width: 92px;
  height: 92px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: fixed;
  right: -10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  box-shadow: 0px 3px 6px black;
  ${(props) => props.theme.breakpoints.between("xs", "sm")} {
    width: 82px;
    height: 82px;
  }
`;

// Styled component for the rounded box with fixed positioning
const StyledSecondBox = styled(Box)`
  margin: 2px;
  border-radius: 50%;
  border: 3px solid #2660AD;
`;

// Styled component for the image
const StyledImage = styled("img")`
  padding: 15px;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

interface IBidIconrops {
  handleClick: () => void;
}

const BulkBidFloatingIcon = ({ handleClick }: IBidIconrops) => {
  return (
    <StyledBox>
      <StyledSecondBox>
        <StyledImage
          src="/images/assets/bidIcon.png"
          alt="bidIcon"
          title="Select items to bulk prebid or watchlist"
          onClick={handleClick}
        />
      </StyledSecondBox>
    </StyledBox>
  );
};

export default BulkBidFloatingIcon;
